import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import { Button, Dialog } from '@unite-us/ui';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import DeleteButton from '../../common/DeleteButton';
import { useArchiveInsurance } from '../hooks/useArchiveInsurance';
export var ArchiveInsurance = function ArchiveInsurance(_ref) {
  var _linkedScc$, _insurance$plan;
  var contact = _ref.contact,
    insurance = _ref.insurance,
    linkedScc = _ref.linkedScc;
  var confirmationDialogRef = useRef(null);
  var archiveInsurance = useArchiveInsurance();
  var toolTipText = !!(linkedScc !== null && linkedScc !== void 0 && linkedScc.length) ? "The insurance record cannot be deleted because it is the primary insurance for the following Social Care Coverage: " + ((_linkedScc$ = linkedScc[0]) === null || _linkedScc$ === void 0 || (_linkedScc$ = _linkedScc$.plan) === null || _linkedScc$ === void 0 ? void 0 : _linkedScc$.name) : insurance.ingested ? "This insurance record cannot be deleted because it was ingested from a roster." : "";
  var onOpen = function onOpen() {
    return confirmationDialogRef.current.openDialog();
  };
  var onClose = function onClose() {
    return confirmationDialogRef.current.closeDialog();
  };
  var onConfirm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return archiveInsurance(insurance.id);
          case 2:
            onClose();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onConfirm() {
      return _ref2.apply(this, arguments);
    };
  }();
  var buttonClass = 'capitalize px-5 py-2 flex border border-solid border-dark-pale-blue rounded space-x-2';
  var warningClass = 'text-white border-validation-red bg-validation-red hover:bg-dark-red hover:border-dark-red';
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeleteButton, {
    ariaLabel: "delete",
    id: "delete-insurance-btn",
    onClick: onOpen,
    toolTipText: toolTipText
  }), /*#__PURE__*/React.createElement(Dialog, {
    onCloseModal: onClose,
    onRequestClose: onClose,
    ref: confirmationDialogRef,
    title: "Delete Insurance",
    type: "form"
  }, /*#__PURE__*/React.createElement("p", {
    className: "leading-relaxed"
  }, "You are about to remove", /*#__PURE__*/React.createElement("strong", {
    className: "text-red"
  }, " ", insurance === null || insurance === void 0 || (_insurance$plan = insurance.plan) === null || _insurance$plan === void 0 ? void 0 : _insurance$plan.name, " "), "from", /*#__PURE__*/React.createElement("strong", null, " ", contact.full_name), "."), /*#__PURE__*/React.createElement("p", {
    className: "mt-5"
  }, "This action cannot be undone."), /*#__PURE__*/React.createElement("div", {
    className: "px-2 py-2 flex justify-end"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cx(buttonClass, 'border-dark-pale-blue bg-white text-dark-blue mr-6'),
    onClick: onClose,
    label: 'Cancel'
  }), /*#__PURE__*/React.createElement(Button, {
    className: cx(buttonClass, warningClass),
    id: "confirmation-dialog-confirm",
    label: 'Delete',
    onClick: onConfirm
  }))));
};
ArchiveInsurance.propTypes = {
  contact: PropTypes.object.isRequired,
  insurance: PropTypes.object.isRequired,
  linkedScc: PropTypes.array
};
//# sourceMappingURL=ArchiveInsurance.js.map